import { ROUTES } from "@/constants/routes";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { NavLink } from "react-router-dom";
import { PlusIcon } from "lucide-react";
import SearchInput from "../search-input";
import { useAlertsFilterStore } from "@/features/alerts/stores";
import AlertsFilterComponent from "@/features/alerts/components/filter-component";

const WarningsPageHeader = () => {
  const { t } = useTranslation();
  const { searchValue, setSearchValue } = useAlertsFilterStore();
  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.alerts")}</h1>
      <div className="flex items-center gap-2 flex-1 justify-end">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          className="max-w-72 hidden lg:flex"
        />
        <div className="hidden lg:block">
          <AlertsFilterComponent />
        </div>
        <NavLink to={ROUTES.ALERT_CREATE}>
          <Button>
            <PlusIcon />
            <span className="hidden sm:inline">
              {t("modules.alerts.keys.add_alert")}
            </span>
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default WarningsPageHeader;
